import type { FileInfo } from '../../../../api/files';

export const isPreviewableFile = (file: FileInfo): boolean => {
	const mimeType = file.meta['@mime']?.toLowerCase();

	if (!mimeType) return false;

	return (
		mimeType.startsWith('application/pdf') ||
		(mimeType.startsWith('image/') &&
			(mimeType === 'image/png' || mimeType === 'image/jpeg' || mimeType === 'image/jpg' || mimeType === 'image/gif'))
	);
};

export const getPdfUploadOrder = (pdf: File, pages: File[]): File[] => [pdf, ...pages];

export const isImageFile = (file: FileInfo): boolean => Boolean(file.meta['@mime']?.toLowerCase().startsWith('image/'));

export const uploadFilesInOrder = async (
	files: File[],
	upload: (file: File) => Promise<string | null>,
): Promise<string[] | null> => {
	const uploadedFileIds: string[] = [];

	for (const file of files) {
		const uploadedFileId = await upload(file).catch(() => null);
		if (!uploadedFileId) return null;
		uploadedFileIds.push(uploadedFileId);
	}

	return uploadedFileIds;
};
